import React from 'react';
import { object } from 'prop-types';
import RelayQueryLookupRenderer from 'relay-query-lookup-renderer';
import Footer from '../Footer/Footer';

const FooterRenderer = props => {
    const { environment, initialVariables, query } = props;

    return (
        <RelayQueryLookupRenderer
            lookup
            environment={environment}
            query={query}
            variables={initialVariables}
            render={({ error, props: rendererProps }) => {
                // eslint-disable-line react/display-name, react/prop-types
                if (error) {
                    return null;
                } else if (rendererProps) {
                    return <Footer {...rendererProps} />;
                } else {
                    return null;
                }
            }}
        />
    );
};

FooterRenderer.propTypes = {
    environment: object,
    initialVariables: object,
    query: object,
};

export default FooterRenderer;
